import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.link)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: $props.link,
        class: "external",
        target: "_blank",
        rel: "noopener noreferrer"
      }, [
        _createElementVNode("strong", null, _toDisplayString($props.name), 1)
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString($props.name), 1))
}